export default __webpack_public_path__ + "static/1-510daa0ae70ebf4f376810c4d699d2a7.jpeg";